import React, { useState, useEffect } from 'react';
import { Card, Select, Row, Col, Radio, Spin } from "antd";
import { Column } from '@ant-design/plots';
import { useSelector, useDispatch } from "react-redux";

// Constants
import { TEMPLATE } from "../../../../constants";
import { monthlyChart } from "../../constant"

// Components
import { FilterSelect } from "../../../../components/TableList";

// Redux Actions

//services
import { REDUX as REDUX_UTIL } from "../../../../services/util";

import { calculateTotals, getColor, monthlyChartData, monthlyGroupData } from "../../handler"
import { dashboardHDLR } from "../../../../handlers"

// Style
import "../../index.css";

const { reduxStoreWrapper } = REDUX_UTIL;

const { optionList, groupedOptions } = TEMPLATE.DASHBOARD

const MonthlyStatistics = (props) =>{
    const { selection, loading } = props;

    // const dispatch = useDispatch()

    const summaries = useSelector(reduxStoreWrapper("dashboard.monthly.summaries"));

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [valueComp, setValueComp] = useState(["ALL"]);
    const [monthlyData, setMonthlyData] = useState(summaries);
    const [isFilter, setIsFilter] = useState(false);
    const [load, setLoad] = useState(false);
    const [option, setOption] = useState("RequestedAmount");
    const [groupedData, setGroupedData] = useState({
      RequestedAmount: [],
      NetDisbursementAmount: [],
      AdminFees: [],
      TotalApplications: [],
      TotalApplicants: [],
      NewApplicants: [],
    });

    const currentYear = new Date().getFullYear();
    const optionsYear = Array.from({ length: 5 }, (v, i) => ({
        value: currentYear - i,
        label: (currentYear - i).toString(),
    }));

    useEffect(() => {
      if (!load && summaries.length > 0) {
        setMonthlyData(summaries);
        setLoad(true);
      }
    }, [load, summaries]);

    const handleChange = (e) => {
      setOption(e.target.value);
    };

    // useEffect(() => {
    //   dashboardHDLR.applyFilters(summaries, valueComp, selectedYear, setMonthlyData, setIsFilter);
    // }, [summaries, valueComp, selectedYear]);


    const applyFilters = (companies, year) => {
      dashboardHDLR.applyFiltersMonth(summaries, companies, year, setMonthlyData, setIsFilter);
    };
    
    const onChangeSelect = (newValue) => {
      setIsFilter(true);
      setValueComp(newValue);
      applyFilters(newValue, selectedYear);
    };

    const handleYearChange = (year) => {
      setIsFilter(true);
      setSelectedYear(year);
      applyFilters(valueComp, year);
    };

      useEffect(() => {
        if (monthlyData.length > 0 && selectedYear) {
          const chartData = monthlyGroupData(monthlyData, selectedYear) || [];
          const selectedDataChart = monthlyChartData(chartData);

          const updatedGroupedData = {
            RequestedAmount: [],
            NetDisbursementAmount: [],
            AdminFees: [],
            TotalApplications: [],
            TotalApplicants: [],
            NewApplicants: [],
          };
    
          selectedDataChart.forEach((item) => {
            updatedGroupedData.RequestedAmount.push({ month: item.month, value: item.total_pr_reqAmount || 0 });
            updatedGroupedData.NetDisbursementAmount.push({ month: item.month, value: item.total_pr_disbursed || 0 });
            updatedGroupedData.AdminFees.push({ month: item.month, value: item.total_pr_fee || 0 });
            updatedGroupedData.TotalApplications.push({ month: item.month, value: item.total_pr_request || 0 });
            updatedGroupedData.TotalApplicants.push({ month: item.month, value: item.total_pr_applicants || 0 });
            updatedGroupedData.NewApplicants.push({ month: item.month, value: item.total_pr_new_applicants || 0});
          });
    
          setGroupedData(updatedGroupedData);
        }
      }, [monthlyData, selectedYear]);

    const totals = calculateTotals(monthlyData)

    const config = monthlyChart(groupedData, option)

    return (
        <Card className="card-shadow height-card">
          <div className="row-space header-card">
            <span className="title-card">M-O-M Statistics</span>
            <div>
              <Select
                defaultValue={currentYear}
                style={{ width: 100, marginRight: "9px" }}
                options={optionsYear}
                onChange={handleYearChange}
              />
              <FilterSelect
                selection={selection}
                style={{ width: 170, height: 32 }}
                selectedData={valueComp}
                onChangeSelect={onChangeSelect}
              />
            </div>
          </div>

          <Row style={{marginLeft: "24px"}}>
            {groupedOptions?.map((group, colIndex) => (
              <Col key={colIndex}>
                <Radio.Group value={option} onChange={handleChange}>
                  {group?.map((optionKey, rowIndex) => {
                    const optionDetail = optionList.find(opt => opt.value === optionKey);
                    return (
                      <Row key={rowIndex}>
                        <Radio value={optionDetail.value} style={{ fontSize: "12px" }}>
                          <div style={{ display: "flex", alignItems: "center", marginTop: "3px" }}>
                            <div className='color-round' style={{ backgroundColor: getColor(optionDetail.value) }}></div>
                            <div style={{ fontSize: "11px" }}>{optionDetail.title}</div>
                          </div>
                        </Radio>
                      </Row>
                    );
                  })}
                </Radio.Group>
              </Col>
            ))}
          </Row>
          <div style={{width: "100%", height: "352px", margin: "5px 8px"}}>
            {loading || isFilter ? (
              <Spin style={{width: "100%", height: "352px", display: "flex", alignItems: "center", justifyContent: "center"}} />
            ) : (
              <Column
                key={option}
                {...config}
              />
            )}
          </div>
          <Row style={{ display: "flex", justifyContent: "flex-start", padding: "0px 20px" }}>
            <Col span={8} className="daily">Total Requested Amount - RM{totals.total_pr_reqAmount}</Col>
            <Col span={10} className="daily">Total Net Disbursement Amount - RM{totals.total_pr_disbursed}</Col>
            <Col span={6} className="daily">Total Admin Fees - RM{totals.total_pr_fee}</Col>
          </Row>
          <Row style={{ display: "flex", justifyContent: "flex-start", padding: "10px 20px" }}>
            <Col span={8} className="daily">Total Applications - {totals.total_pr_request}</Col>
            <Col span={10} className="daily">Total Applicants - {totals.total_employee_applied}</Col>
            <Col span={6} className="daily">Total New Applicants - {totals.total_employee_first_applied}</Col>
          </Row>

          
        </Card>
    );
};

export default MonthlyStatistics;